import { cn } from "@/lib/utils/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        // Very subtle by default; tuned for light and dark
        "animate-pulse rounded-md bg-muted/50 dark:bg-muted/50",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
